(function () {
  var SNAPMINT_SELECTORS = '#sm-widget-btn, [class*="snap_emi"], [class*="below_pdp_widget"]';

  var style = document.createElement('style');
  style.textContent = '#sm-widget-btn.snap_emi_txt.snap_emi_txt_wrapper.below_pdp_widget { margin: -10px 0 30px !important; }';
  document.head.appendChild(style);

  function moveSnapmint() {
    var anchor = document.getElementById('snapmint-anchor');
    if (!anchor) return;
    var widget = document.querySelector(SNAPMINT_SELECTORS);
    if (!widget) return;
    anchor.appendChild(widget);
  }

  function placeAnchorBeforeTrustBadges() {
    var anchor = document.getElementById('snapmint-anchor');
    if (!anchor) return;
    var trustBadges = document.querySelector('.TrustBadges');
    if (!trustBadges) return;
    anchor.style.marginTop = '20px';
    anchor.style.marginBottom = '20px';
    trustBadges.parentNode.insertBefore(anchor, trustBadges);
  }

  var widgetObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType !== 1) continue;
        var id = node.id || '';
        var cls = typeof node.className === 'string' ? node.className : '';
        if (id === 'sm-widget-btn' || cls.indexOf('snap_emi') !== -1 || cls.indexOf('below_pdp_widget') !== -1) {
          widgetObserver.disconnect();
          moveSnapmint();
          return;
        }
      }
    }
  });

  var trustObserver = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      for (var j = 0; j < mutations[i].addedNodes.length; j++) {
        var node = mutations[i].addedNodes[j];
        if (node.nodeType !== 1) continue;
        var cls = typeof node.className === 'string' ? node.className : '';
        if (cls.indexOf('TrustBadges') !== -1 || node.querySelector('.TrustBadges')) {
          trustObserver.disconnect();
          placeAnchorBeforeTrustBadges();
          return;
        }
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector(SNAPMINT_SELECTORS)) {
      moveSnapmint();
    } else {
      widgetObserver.observe(document.body, { childList: true, subtree: true });
    }

    if (document.querySelector('.TrustBadges')) {
      placeAnchorBeforeTrustBadges();
    } else {
      trustObserver.observe(document.body, { childList: true, subtree: true });
    }
  });
})();
